import styled from "styled-components";

export const StyledResultTotal = styled.div`
  width: 100%; 
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: transparent;
  border: 0.2vw solid #424242;
	background-color: #000;
	border-radius: 5px;
	padding: 1vw;
	box-sizing: border-box;
	margin-bottom: 20px;
`;

export const StyledText = styled.span`
	font-size: 1.4vw;
	font-family: 'Inter medium', 'Suit medium';
	color: #ffffffcf;
	${({ theme }) =>
			theme.media.monitor(
			`
				font-size: 27px;
			`,
		)}
	${({ theme }) =>
			theme.media.mobile(
			`
				font-size: 3.2vw;
			`,
		)}
`;